import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { SharedModule } from "@shared/shared.module";
import { TeamScorecard } from "@shared/models/team-scorecard";

import { Observable } from "rxjs";
import { environment } from "@env/environment";

const qwiserUrl = `${environment.apiBaseUrl}platform/qwiser`;
const exportUrl = `${environment.apiBaseUrl}platform/export`;

const headers = new HttpHeaders({
  'x-no-notification': 'true'
});

@Injectable({
  providedIn: SharedModule
})
export class QWiserService {

  constructor(private http: HttpClient) { }
  getAddons(): Observable<QWiser.AddonModel[]> {
    return this.http.get<QWiser.AddonModel[]>(`${qwiserUrl}/addons`);
  }

  initializeTabList(addonId: any, scopeId: any): Observable<TeamScorecard.InitializeStepModel> {
    let params = new HttpParams();
    if (scopeId) {
      params = params.append('scopeId', scopeId);
    }
    return this.http.get<TeamScorecard.InitializeStepModel>(`${qwiserUrl}/addons/${addonId}/initialize`, { params });
  }

  updateinitializeTabList(isUpdate?: any, analysisId?: any, addonId?: any,): Observable<TeamScorecard.InitializeStepModel[]> {
    let params = new HttpParams();
    if (analysisId) {
      params = params.append('analysisId', analysisId);
    }

    if (isUpdate) {
      params = params.append('isUpdate', isUpdate);
    }

    return this.http.get<TeamScorecard.InitializeStepModel[]>(`${qwiserUrl}/addons/${addonId}/initialize`, { params });
  }

  getFieldUrl(route): Observable<any> {
    return this.http.get<any>(`${environment.apiBaseUrl}` + route);
  }

 // ,teamId
 //  teamList(page): Observable<any> {
 //
 //    const body = {
 //      page
 //    }
 //    return this.http.post<any>(`${qwiserUrl}/analyses/teams`, body );
 //  }

  createV2(analysis: any): Observable<any> {
    return this.http.post<any>(`${qwiserUrl}/analysis`, analysis);
  }

  updateV2Analysis(id: string, data: any): Observable<any> {
    return this.http.put<any>(`${qwiserUrl}/${id}`, data);
  }

  cancel(id: string): Observable<any> {
    return this.http.post<any>(`${qwiserUrl}/${id}/stop`, {}, { headers });
  }

  list(body
    ): Observable<any> {
    return this.http.post<any>(`${qwiserUrl}/analyses`, body , { headers });
  }

  sync(id: string): Observable<any> {
    return this.http.put<any>(`${qwiserUrl}/${id}/reanalyse`, {}, { headers });
  }

  delete(id: string): Observable<any> {
    return this.http.delete<any>(`${qwiserUrl}/analysis/${id}`);
  }


  // detail

  getQwiserList(id: string): Observable<any> {
    return this.http.get<any>(`${qwiserUrl}/analysis/${id}`);
  }

  getQwiserProcess(analysisId: string): Observable<any> {
    let params = new HttpParams();

    if (analysisId) {
      params = params.append('analysisId', analysisId);
    }

    return this.http.get<any>(`${qwiserUrl}/process`, { params });
  }

  getTeamsData(analysisIds: string, widgetTypeEnum: string, fromDate: string, toDate?: string,overallData? :boolean,issueType? :any, displayType? :any, metricType?:any): Observable<any> {
    const body: any = {
      widgetTypeEnum,
      analysisIds,
      fromDate,
      toDate,
      overallData,
      issueType,
      displayType,
      metricType,
    };

    return this.http.post<any>(`${qwiserUrl}/analysis/${analysisIds}/widget/result`, body, { headers });
  }

  exportQwiserData(searchValue?:any, sort?: any, sortDirection?: any,status?:any,qualityGateStatus?:any,filterTeams?:any,branches?:any,metricType?:any,exportType?:any): Observable<HttpResponse<Blob>> {
    const body = {
      searchValue,
      sort,
      sortDirection,
      status,
      qualityGateStatus,
      filterTeams,
      branches,
      metricType,
      exportType,
    };
    return this.http.post(`${exportUrl}/qwiser-analyses`, body, { responseType: 'blob', observe: 'response' });
  }

  getExportDataListByQuality(metricType?: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('metricType', metricType);
    return this.http.get(`${exportUrl}`, {params});
  }

}
